export const NS = {
  ALL: 'all',
  ACCOUNT_DELETION: 'accountDeletion',
  ACCOUNT_DELETION_CONFIRM: 'accountDeletionConfirm',
  ACCOUNTS: 'accounts',
  ACTIVITY_LOG: 'activityLog',
  BALANCE_HISTORY: 'balanceHistory',
  BALANCE_ROLLOUT: 'balanceRollout',
  BILLING_HISTORY: 'billingHistory',
  BUDGET_MANAGER: 'budgetManager',
  CATEGORY_MANAGER: 'categoryManager',
  CLOSING_HISTORY: 'closingHistory',
  COMMON: 'common',
  DASHBOARD: 'dashboard',
  DEADLINES: 'deadlines',
  DEBT_MANAGER: 'debtManager',
  DEBT_PAYOFF_PLAN: 'debtPayoffPlan',
  EXPENSE_GROUP: 'expenseGroup',
  EXPENSES_LIST: 'expensesList',
  FEATURE_HIGHLIGHTS: 'featureHighlights',
  FINANCE_ANALYSIS: 'financeAnalysis',
  FORECAST_ROLLOUT: 'forecastRollout',
  FORECAST_AI_HELPER: 'forecastAiHelper',
  FORECAST_AI_HISTORY: 'forecastAiHistory',
  FORECAST_PAGE: 'forecastPage',
  FORECAST_SUMMARY_CALENDAR: 'forecastSummaryCalendar',
  FORGOT_PASSWORD: 'forgotPassword',
  GOAL_MANAGER: 'goalManager',
  GPT_ANALYSIS: 'gptAnalysis',
  HOME: 'home',
  INCOME_LIST: 'incomeList',
  INVITE: 'invite',
  LEGAL: 'legal',
  LIABILITY_MANAGER: 'liabilityManager',
  LOGIN: 'login',
  MENU: 'menu',
  MY_INSIGHTS: 'myInsights',
  PERSONAL_CIRCLE: 'personalCircle',
  PUBLIC_INSIGHTS: 'publicInsights',
  REAL_TRANSACTIONS: 'realTransactions',
  RECURRENT_EXPENSE_MANAGER: 'recurrentExpenseManager',
  RECURRENT_HUB: 'recurrentHub',
  RECURRENT_INCOME_MANAGER: 'recurrentIncomeManager',
  REGISTER: 'register',
  RESET_PASSWORD: 'resetPassword',
  REWARD_MANAGER: 'rewardManager',
  SETUP: 'setup',
  STATUS: 'status',
  SUBSCRIPTION: 'subscription',
  SUPPORT_HELP: 'supportHelp',
  TASK_EVENTS: 'taskEvents',
  TASKS_TO_CONFIRM: 'tasksToConfirm',
  TEMPO_MINT: 'tempoMint',
  TIMEZONES: 'timezones',
  TRANSACTIONS_HUB: 'transactionsHub',
};

export default NS;
